'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var openStackMap = function openStackMap(callNumber) {
  return {
    eventCategory: 'stack-map',
    eventAction: 'clicked',
    eventLabel: callNumber,
    sendToLibrary: true
  };
};

exports.default = openStackMap;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/ga-event-templates/lib/openStackMap.js
// module id = 1418
// module chunks = 1